import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ListExpandDialogComponent } from 'src/app/ag-grid-components/simple-list-cell-renderer/list-expand-dialog/list-expand-dialog.component';

@Component({
  selector: 'app-price-range-popup',
  templateUrl: './price-range-popup.component.html',
  styleUrls: ['./price-range-popup.component.scss']
})
export class PriceRangePopupComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<ListExpandDialogComponent>
  ) {}

  ngOnInit(): void {
    this.data;
  }
}